<div class="ard">
  <header class="ard-head">
    <div class="ard-title">
      <button type="button" class="link" *ngIf="report && !data.reportId" (click)="back()">← Back</button>
      <h2>AI {{ typeLabel }}</h2>
    </div>
    <div class="ard-actions">
      <button type="button" class="link" (click)="openHub()">Open in AI Reports</button>
      <button type="button" class="close" (click)="close()" aria-label="Close">✕</button>
    </div>
  </header>

  <div class="ard-body">
    <ng-container *ngIf="!report && !loading">
      <app-ai-report-form
        [type]="data.type"
        [preset]="data.preset || null"
        [lockProject]="projectLocked"
        [busy]="generating"
        (submitted)="generate($event)"
      ></app-ai-report-form>

      <p class="ard-wait" *ngIf="generating">Collecting project data and writing the report…</p>

      <section class="ard-recent" *ngIf="recent.length && !generating">
        <h4>Recent reports</h4>
        <ul>
          <li *ngFor="let r of recent" (click)="open(r.id)" tabindex="0" (keydown.enter)="open(r.id)">
            <span class="r-title">{{ r.title }}</span>
            <span class="r-meta">{{ r.ai_used ? 'AI' : 'Rule-based' }} · {{ r.created_at | date: 'short' }}</span>
          </li>
        </ul>
      </section>
    </ng-container>

    <p class="ard-wait" *ngIf="loading">Loading report…</p>

    <app-ai-report-view *ngIf="report && !loading" [report]="report" [busy]="generating" (regenerate)="regenerate()"></app-ai-report-view>
  </div>
</div>
